module.exports = __webpack_public_path__ + "fonts/junction-regular.32b25992.ttf";